"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implements a channel that directly forwards the requests to the given request handler.
 */
class LoopbackChannel {
    constructor(requestHandler) {
        this.requestHandler = requestHandler;
        this.id = 0;
    }
    sendRequest(request, messageIdCallback) {
        const curId = this.id++;
        if (messageIdCallback) {
            messageIdCallback(curId);
        }
        return this.requestHandler.handleRequest(request, curId);
    }
    sendNotification(notification) {
        return this.requestHandler.handleNotification(notification);
    }
    toString() {
        return "Loopback";
    }
}
exports.LoopbackChannel = LoopbackChannel;
//# sourceMappingURL=Channel.js.map